var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.DraggableSidebar,
    _vm._b(
      {
        attrs: { right: "", show: "", width: 400 },
        on: { "update:show": _setup.onUpdateShow },
      },
      "DraggableSidebar",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        { staticClass: "full-height editor" },
        [
          _c(_setup.codemirror, {
            staticClass: "full-height",
            attrs: { options: _setup.cmOptions },
            on: { input: _setup.onCmCodeChange },
            model: {
              value: _setup.geojson,
              callback: function ($$v) {
                _setup.geojson = $$v
              },
              expression: "geojson",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }